<div class="container-fluid signinbody">
    <div class="row justify-content-center">
      <div class="  col-sm-10 col-md-7 col-lg-6 col-xl-5 rounded m-2 text-center">
        <img src="assets/img/Fluidra_Blue.png" alt="" class="logo" />
        <div class="box">
            <br>
            <h5 class="fl-color">{{ "lang.password_forgot" | translate }}</h5>
            <small class="fl-color">{{ "lang.password_forgot_message" | translate }}</small>
          <div class="signin-innerbox px-4">
            <br>
            <form [formGroup]="resetForm" #form="ngForm">
              <div class="signin-fields">
                <div class="row">
                  <div class="col mb-2 input-group">
                    <span class="input-group-text"><i class="fa-regular fa-user"></i></span>
                    <input type="email" id="email" name="email" formControlName="email" placeholder="{{'lang.email_address' |translate}}" required minlength="1" maxlength="250" class="form-control"
                      [class.is-invalid]="email.invalid && (email.dirty || email.touched)" />
                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
                      <div *ngIf="email.errors?.['required']">
                        {{'lang.email_address' | translate}} is required.
                      </div>
                      <div *ngIf="email.errors?.['minlength']">
                        {{'lang.email_address' | translate}} must have at least 1 character.
                      </div>
                      <div *ngIf="email.errors?.['maxlength']">
                        {{'lang.email_address' | translate}} must have at most 250 characters.
                      </div>
                      <div *ngIf="!email.errors?.['required'] && !email.errors?.['minlength'] && !email.errors?.['maxlength'] && email.errors?.['emailValidator']">
                        Invalid  {{'lang.email_address' | translate}} format.
                      </div>
                    </div>
                  </div>
                </div>
        
                <div class="signinBottom col mt-2 mb-2 d-grid">
                  <button type="submit" (click)="validate()" class="btn signin-btn btn-signin">{{'lang.reset_password' | translate}}</button>
              </div>
              </div>
            </form>
          </div>
        </div>
        <div class="signin-btm-txt">
            <p>
            Back to
            <a routerLink="/signin">{{ "lang.sign_in" | translate }}</a>
            </p>
        </div>
      </div>
    </div>
  </div>